import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'ci.class_metrics'

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Class metrics',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: -1,
      fetch: 0,
      update: -1,
      delete: -1,
      downloadList: -1,
      uploadList: -1
    }
  },

  columns: () => {
    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left' },
      { name: 'name', label: 'Name', field: 'name', align: 'left' },
      { name: 'ci_classes_field', label: 'Field name', field: 'ci_classes_field' },
      { name: 'display_order', label: 'Display order', field: 'display_order' }
    ]
  }
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
